// Reading a workflow read model whichever way it arrives: camelized by the
// axios layer (humps), or snake_case (tests, raw fetches).

const camel = (key) => key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

export const field = (obj, key) => obj?.[camel(key)] ?? obj?.[key];

/** Declined (halted), withdrawn, or superseded: nothing more to sign or change.
 *  `deadlinePassed`: the sign-by deadline is over, so nobody can sign or vote
 *  until the initiator moves it. */
export function signingState(collection) {
  const status = field(collection, 'status') || 'active';
  const superseded = Boolean(field(collection, 'superseded_at'));
  return {
    status,
    superseded,
    ended: status === 'rejected' || status === 'withdrawn' || superseded,
    deadlinePassed: Boolean(field(collection, 'deadline_passed')),
  };
}
